import React from "react";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "./styles/demo/Demos.scss";
import "./styles/layout/layout.scss";
import RequireAuth from "./RequireAuth";
import { LayoutProvider } from "./admin/layout/context/layoutcontext";
import { PrimeReactProvider } from "primereact/api";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./public/home";
import Login from "./public/authentications/login";
import ActivateAccount from "./public/authentications/activate";
import NotFound from "./NotFound";
import AdminDashboard from "./admin/dashboard/dashboard";
import LandingDashboard from "./public/demo/demo";
import ContactUs from "./public/contactUs/ContactUs";
import AboutUs from "./public/aboutUs/aboutUs";


const App = () => {
  return (
    <PrimeReactProvider>
      <LayoutProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/login" element={<Login />} /> */}
            <Route path="/demo" element={<LandingDashboard />} />
            <Route path="contact-us" element={<ContactUs/>}/>
            <Route path="about-us" element={<AboutUs/>}/>
            <Route
              path="/activate/:activateToken"
              element={<ActivateAccount />}
            />
            <Route element={<RequireAuth allowedRoles="administrator" />}>
              <Route path="/admin" element={<AdminDashboard />} />

            </Route>
            <Route path="/*" element={<NotFound />} />
          </Routes>
        </Router>
      </LayoutProvider>
    </PrimeReactProvider>
  );
};


export default App;
